/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as PairRouteImport } from './routes/pair'
import { Route as ConnectRouteImport } from './routes/connect'
import { Route as ChatRouteImport } from './routes/_chat'
import { Route as ChatIndexRouteImport } from './routes/_chat.index'
import { Route as SettingsSourceControlRouteImport } from './routes/settings.source-control'
import { Route as SettingsProvidersRouteImport } from './routes/settings.providers'
import { Route as SettingsKeybindingsRouteImport } from './routes/settings.keybindings'
import { Route as SettingsIntegrationsRouteImport } from './routes/settings.integrations'
import { Route as SettingsGeneralRouteImport } from './routes/settings.general'
import { Route as SettingsErpInstancesRouteImport } from './routes/settings.erp-instances'
import { Route as SettingsDiagnosticsRouteImport } from './routes/settings.diagnostics'
import { Route as SettingsConnectionsRouteImport } from './routes/settings.connections'
import { Route as SettingsBetaRouteImport } from './routes/settings.beta'
import { Route as SettingsArchivedRouteImport } from './routes/settings.archived'
import { Route as ConnectCallbackRouteImport } from './routes/connect_.callback'
import { Route as ChatDraftDraftIdRouteImport } from './routes/_chat.draft.$draftId'
import { Route as ChatEnvironmentIdThreadIdRouteImport } from './routes/_chat.$environmentId.$threadId'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PairRoute = PairRouteImport.update({
  id: '/pair',
  path: '/pair',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectRoute = ConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatRoute = ChatRouteImport.update({
  id: '/_chat',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatIndexRoute = ChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChatRoute,
} as any)
const SettingsSourceControlRoute = SettingsSourceControlRouteImport.update({
  id: '/source-control',
  path: '/source-control',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsProvidersRoute = SettingsProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsKeybindingsRoute = SettingsKeybindingsRouteImport.update({
  id: '/keybindings',
  path: '/keybindings',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsIntegrationsRoute = SettingsIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsGeneralRoute = SettingsGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsErpInstancesRoute = SettingsErpInstancesRouteImport.update({
  id: '/erp-instances',
  path: '/erp-instances',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsDiagnosticsRoute = SettingsDiagnosticsRouteImport.update({
  id: '/diagnostics',
  path: '/diagnostics',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsConnectionsRoute = SettingsConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsBetaRoute = SettingsBetaRouteImport.update({
  id: '/beta',
  path: '/beta',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsArchivedRoute = SettingsArchivedRouteImport.update({
  id: '/archived',
  path: '/archived',
  getParentRoute: () => SettingsRoute,
} as any)
const ConnectCallbackRoute = ConnectCallbackRouteImport.update({
  id: '/connect_/callback',
  path: '/connect/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatDraftDraftIdRoute = ChatDraftDraftIdRouteImport.update({
  id: '/draft/$draftId',
  path: '/draft/$draftId',
  getParentRoute: () => ChatRoute,
} as any)
const ChatEnvironmentIdThreadIdRoute =
  ChatEnvironmentIdThreadIdRouteImport.update({
    id: '/$environmentId/$threadId',
    path: '/$environmentId/$threadId',
    getParentRoute: () => ChatRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ChatIndexRoute
  '/connect': typeof ConnectRoute
  '/pair': typeof PairRoute
  '/settings': typeof SettingsRouteWithChildren
  '/connect/callback': typeof ConnectCallbackRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/beta': typeof SettingsBetaRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/erp-instances': typeof SettingsErpInstancesRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/source-control': typeof SettingsSourceControlRoute
  '/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/draft/$draftId': typeof ChatDraftDraftIdRoute
}
export interface FileRoutesByTo {
  '/connect': typeof ConnectRoute
  '/pair': typeof PairRoute
  '/settings': typeof SettingsRouteWithChildren
  '/connect/callback': typeof ConnectCallbackRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/beta': typeof SettingsBetaRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/erp-instances': typeof SettingsErpInstancesRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/source-control': typeof SettingsSourceControlRoute
  '/': typeof ChatIndexRoute
  '/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/draft/$draftId': typeof ChatDraftDraftIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_chat': typeof ChatRouteWithChildren
  '/connect': typeof ConnectRoute
  '/pair': typeof PairRoute
  '/settings': typeof SettingsRouteWithChildren
  '/connect_/callback': typeof ConnectCallbackRoute
  '/settings/archived': typeof SettingsArchivedRoute
  '/settings/beta': typeof SettingsBetaRoute
  '/settings/connections': typeof SettingsConnectionsRoute
  '/settings/diagnostics': typeof SettingsDiagnosticsRoute
  '/settings/erp-instances': typeof SettingsErpInstancesRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/keybindings': typeof SettingsKeybindingsRoute
  '/settings/providers': typeof SettingsProvidersRoute
  '/settings/source-control': typeof SettingsSourceControlRoute
  '/_chat/': typeof ChatIndexRoute
  '/_chat/$environmentId/$threadId': typeof ChatEnvironmentIdThreadIdRoute
  '/_chat/draft/$draftId': typeof ChatDraftDraftIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/connect'
    | '/pair'
    | '/settings'
    | '/connect/callback'
    | '/settings/archived'
    | '/settings/beta'
    | '/settings/connections'
    | '/settings/diagnostics'
    | '/settings/erp-instances'
    | '/settings/general'
    | '/settings/integrations'
    | '/settings/keybindings'
    | '/settings/providers'
    | '/settings/source-control'
    | '/$environmentId/$threadId'
    | '/draft/$draftId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/connect'
    | '/pair'
    | '/settings'
    | '/connect/callback'
    | '/settings/archived'
    | '/settings/beta'
    | '/settings/connections'
    | '/settings/diagnostics'
    | '/settings/erp-instances'
    | '/settings/general'
    | '/settings/integrations'
    | '/settings/keybindings'
    | '/settings/providers'
    | '/settings/source-control'
    | '/'
    | '/$environmentId/$threadId'
    | '/draft/$draftId'
  id:
    | '__root__'
    | '/_chat'
    | '/connect'
    | '/pair'
    | '/settings'
    | '/connect_/callback'
    | '/settings/archived'
    | '/settings/beta'
    | '/settings/connections'
    | '/settings/diagnostics'
    | '/settings/erp-instances'
    | '/settings/general'
    | '/settings/integrations'
    | '/settings/keybindings'
    | '/settings/providers'
    | '/settings/source-control'
    | '/_chat/'
    | '/_chat/$environmentId/$threadId'
    | '/_chat/draft/$draftId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ChatRoute: typeof ChatRouteWithChildren
  ConnectRoute: typeof ConnectRoute
  PairRoute: typeof PairRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  ConnectCallbackRoute: typeof ConnectCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pair': {
      id: '/pair'
      path: '/pair'
      fullPath: '/pair'
      preLoaderRoute: typeof PairRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect': {
      id: '/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof ConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat': {
      id: '/_chat'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ChatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat/': {
      id: '/_chat/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ChatIndexRouteImport
      parentRoute: typeof ChatRoute
    }
    '/settings/source-control': {
      id: '/settings/source-control'
      path: '/source-control'
      fullPath: '/settings/source-control'
      preLoaderRoute: typeof SettingsSourceControlRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/providers': {
      id: '/settings/providers'
      path: '/providers'
      fullPath: '/settings/providers'
      preLoaderRoute: typeof SettingsProvidersRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/keybindings': {
      id: '/settings/keybindings'
      path: '/keybindings'
      fullPath: '/settings/keybindings'
      preLoaderRoute: typeof SettingsKeybindingsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/integrations': {
      id: '/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof SettingsIntegrationsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/general': {
      id: '/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SettingsGeneralRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/erp-instances': {
      id: '/settings/erp-instances'
      path: '/erp-instances'
      fullPath: '/settings/erp-instances'
      preLoaderRoute: typeof SettingsErpInstancesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/diagnostics': {
      id: '/settings/diagnostics'
      path: '/diagnostics'
      fullPath: '/settings/diagnostics'
      preLoaderRoute: typeof SettingsDiagnosticsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/connections': {
      id: '/settings/connections'
      path: '/connections'
      fullPath: '/settings/connections'
      preLoaderRoute: typeof SettingsConnectionsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/beta': {
      id: '/settings/beta'
      path: '/beta'
      fullPath: '/settings/beta'
      preLoaderRoute: typeof SettingsBetaRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/archived': {
      id: '/settings/archived'
      path: '/archived'
      fullPath: '/settings/archived'
      preLoaderRoute: typeof SettingsArchivedRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/connect_/callback': {
      id: '/connect_/callback'
      path: '/connect/callback'
      fullPath: '/connect/callback'
      preLoaderRoute: typeof ConnectCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_chat/draft/$draftId': {
      id: '/_chat/draft/$draftId'
      path: '/draft/$draftId'
      fullPath: '/draft/$draftId'
      preLoaderRoute: typeof ChatDraftDraftIdRouteImport
      parentRoute: typeof ChatRoute
    }
    '/_chat/$environmentId/$threadId': {
      id: '/_chat/$environmentId/$threadId'
      path: '/$environmentId/$threadId'
      fullPath: '/$environmentId/$threadId'
      preLoaderRoute: typeof ChatEnvironmentIdThreadIdRouteImport
      parentRoute: typeof ChatRoute
    }
  }
}

interface ChatRouteChildren {
  ChatIndexRoute: typeof ChatIndexRoute
  ChatEnvironmentIdThreadIdRoute: typeof ChatEnvironmentIdThreadIdRoute
  ChatDraftDraftIdRoute: typeof ChatDraftDraftIdRoute
}

const ChatRouteChildren: ChatRouteChildren = {
  ChatIndexRoute: ChatIndexRoute,
  ChatEnvironmentIdThreadIdRoute: ChatEnvironmentIdThreadIdRoute,
  ChatDraftDraftIdRoute: ChatDraftDraftIdRoute,
}

const ChatRouteWithChildren = ChatRoute._addFileChildren(ChatRouteChildren)

interface SettingsRouteChildren {
  SettingsArchivedRoute: typeof SettingsArchivedRoute
  SettingsBetaRoute: typeof SettingsBetaRoute
  SettingsConnectionsRoute: typeof SettingsConnectionsRoute
  SettingsDiagnosticsRoute: typeof SettingsDiagnosticsRoute
  SettingsErpInstancesRoute: typeof SettingsErpInstancesRoute
  SettingsGeneralRoute: typeof SettingsGeneralRoute
  SettingsIntegrationsRoute: typeof SettingsIntegrationsRoute
  SettingsKeybindingsRoute: typeof SettingsKeybindingsRoute
  SettingsProvidersRoute: typeof SettingsProvidersRoute
  SettingsSourceControlRoute: typeof SettingsSourceControlRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsArchivedRoute: SettingsArchivedRoute,
  SettingsBetaRoute: SettingsBetaRoute,
  SettingsConnectionsRoute: SettingsConnectionsRoute,
  SettingsDiagnosticsRoute: SettingsDiagnosticsRoute,
  SettingsErpInstancesRoute: SettingsErpInstancesRoute,
  SettingsGeneralRoute: SettingsGeneralRoute,
  SettingsIntegrationsRoute: SettingsIntegrationsRoute,
  SettingsKeybindingsRoute: SettingsKeybindingsRoute,
  SettingsProvidersRoute: SettingsProvidersRoute,
  SettingsSourceControlRoute: SettingsSourceControlRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  ChatRoute: ChatRouteWithChildren,
  ConnectRoute: ConnectRoute,
  PairRoute: PairRoute,
  SettingsRoute: SettingsRouteWithChildren,
  ConnectCallbackRoute: ConnectCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
